import { LANGUAGES, SECTORS } from "./config.js";
import { isAllLanguages, loadPrefs, savePrefs, selectLanguage, toggleInList } from "./prefs.js";

export function formatTodayDate() {
  return new Intl.DateTimeFormat(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date());
}

export function renderChips(langEl, sectorEl, prefs, onChange) {
  langEl.replaceChildren();
  sectorEl.replaceChildren();

  const allLangs = isAllLanguages(prefs.langs);
  const activeLang = allLangs ? null : prefs.langs[0];

  for (const lang of LANGUAGES) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "chip";
    btn.textContent = lang.label;
    btn.title = lang.native;
    // Only the selected language looks pressed; when showing all, none are pressed.
    btn.setAttribute("aria-pressed", activeLang === lang.code ? "true" : "false");
    btn.addEventListener("click", () => {
      const langs = selectLanguage(prefs.langs, lang.code);
      const next = savePrefs({ ...prefs, langs });
      Object.assign(prefs, next);
      renderChips(langEl, sectorEl, prefs, onChange);
      onChange(prefs);
    });
    langEl.appendChild(btn);
  }

  for (const sector of SECTORS) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "chip";
    btn.textContent = sector.label;
    btn.setAttribute("aria-pressed", prefs.sectors.includes(sector.code) ? "true" : "false");
    btn.addEventListener("click", () => {
      const sectors = toggleInList(prefs.sectors, sector.code, SECTORS.map((s) => s.code));
      const next = savePrefs({ ...prefs, sectors });
      Object.assign(prefs, next);
      renderChips(langEl, sectorEl, prefs, onChange);
      onChange(prefs);
    });
    sectorEl.appendChild(btn);
  }
}

export { loadPrefs };
